// frontend/src/services/api.js
import axios from "axios";

const API_BASE_URL = "https://aitredingbackend.luknos.com/api/v1";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getBotStatus = () => {
  return apiClient.get("/bot/status");
};

export const startBot = () => {
  return apiClient.post("/bot/start");
};

export const stopBot = () => {
  return apiClient.post("/bot/stop");
};

// --- NEW: Function to get the Zerodha login URL from the backend ---
export const getZerodhaLoginUrl = () => {
  return apiClient.get("/bot/zerodha/login-url");
};

// This is now a fallback method, but we keep it
export const submitRequestToken = (request_token) => {
  return apiClient.post("/bot/zerodha/request-token", { request_token });
};

export const getDashboardData = () => {
  return apiClient.get("/bot/dashboard-data");
};

export const getTradeHistory = (page = 1, limit = 10) => {
  return apiClient.get("/bot/trades/history", { params: { page, limit } });
};

export const getBotSettings = () => {
  return apiClient.get("/bot/settings");
};

export const updateBotSetting = (key, value) => {
  return apiClient.post("/bot/settings/update", { key, value });
};

export const triggerInstrumentRefresh = () => {
  return apiClient.post("/bot/run-daily-init");
};

export const panicSquareOffAll = () => {
  return apiClient.post("/bot/panic-square-off");
};

export default apiClient;
